module.exports = __webpack_public_path__ + "static/media/SF-1-if-wrong.8cafe68a.mp3";